import React, { useEffect } from 'react';

const useAddEvent = (eventName = 'default', eventHandler = () => {}) => {
  useEffect(() => {
    window.addEventListener(eventName, eventHandler);
    return () => {
      window.removeEventListener(eventName, eventHandler);
    };
  }, [eventName, eventHandler]);

  return null;
};

export default useAddEvent;

export const dispatchEvent = (eventName = 'default') => {
  const event = new Event(eventName);
  window.dispatchEvent(event);
};
